import React, { useState } from "react";
import { HiMenuAlt3 } from "react-icons/hi";
import { MdOutlineDashboard } from "react-icons/md";
import { RiSettings4Line } from "react-icons/ri";
import { TbReportAnalytics } from "react-icons/tb";
import { AiOutlineUser, AiOutlineHeart } from "react-icons/ai";
import { FiMessageSquare, FiFolder, FiShoppingCart } from "react-icons/fi";
import { Link } from "react-router-dom";


export const SideBar = () => {
  const menus = [
    { name: "NavPanel", link: "/admin/nav-panel", icon: MdOutlineDashboard },
    { name: "Banner", link: "/admin/banner", icon: AiOutlineUser },
    { name: "About-Section", link: "/admin/about-section", icon: FiMessageSquare },
    { name: "Fact Panel", link: "/admin/funFacts", icon: TbReportAnalytics,  },
    { name: "Our Specialisation", link: "/admin/OurSpecialisation", icon: FiFolder },
    { name: "WhychooseusPanel", link: "/admin/wycu", icon: FiShoppingCart },
    { name: "Services", link: "/admin/services", icon: AiOutlineHeart, },
    { name: "CTA", link: "/admin/cta", icon: RiSettings4Line },
    { name: "Partners", link: "/admin/partners", icon: RiSettings4Line },
    { name: "Blog", link: "/admin/blog", icon: RiSettings4Line },
    { name: "Footer", link: "/admin/footer", icon: RiSettings4Line },
    { name: "About Page", link: "/admin/about-page", icon: RiSettings4Line },
    { name: "Service Page", link: "/admin/service-page", icon: RiSettings4Line },
    { name: "Gallery Page ", link: "/admin/gallery", icon: RiSettings4Line },
    { name: "Contact Page ", link: "/admin/ContactUs", icon: RiSettings4Line },

  ];
  const [open, setOpen] = useState(true);
  return (
    <section className="flex gap-6">
      <div
        className={`bg-[#4169E1] ${
          open ? "w-72" : "w-16"
        } duration-500 text-gray-100 px-4`}
      >
        <div className="py-3 flex justify-end">
          <HiMenuAlt3
            size={26}
            className="cursor-pointer"
            onClick={() => setOpen(!open)}
          />
        </div>
        <div className="mt-4 flex flex-col gap-4 relative">
          {menus?.map((menu, i) => (
            <Link
              to={menu?.link}
              key={i}
              className={` ${
                menu?.margin && "mt-5"
              } group flex items-center text-sm  gap-3.5 font-medium p-2 hover:bg-gray-800 rounded-md`}
            >
              <div>{React.createElement(menu?.icon, { size: "20" })}</div>
              <h2
                style={{
                  transitionDelay: `${i + 3}00ms`,
                }}
                className={`whitespace-pre duration-500 ${
                  !open && "opacity-0 translate-x-28 overflow-hidden"
                }`}
              >
                {menu?.name}
              </h2>
              <h2
                className={`${
                  open && "hidden"
                } absolute left-48 bg-white font-semibold whitespace-pre text-gray-900 rounded-md drop-shadow-lg px-0 py-0 w-0 overflow-hidden group-hover:px-2 group-hover:py-1 group-hover:left-14 group-hover:duration-300 group-hover:w-fit  `}
              >
                {menu?.name}
              </h2>
            </Link>
          ))}
        </div>
      </div>
    
    </section>
  );
};

